import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import axios from "axios";
import { getSweetAlert } from "../helper";
import {
  GET_GLOBAL_BAN_STATUS,
  UPDATE_GLOBAL_BAN_STATUS,
} from "../constant/endpoint";

const UpdateGlobalData = () => {
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchStatus = async () => {
    try {
      setLoading(true);
      const response = await axios.get(GET_GLOBAL_BAN_STATUS);
      if (response.data.status === "success") {
        setActive(response.data.data.active);
      } else {
        getSweetAlert("error", "Failed to fetch current status");
      }
    } catch (error) {
      console.error(error);
      getSweetAlert("error", "Error fetching ban status");
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async () => {
    try {
      setLoading(true);
      const newStatus = !active;
      const response = await axios.post(UPDATE_GLOBAL_BAN_STATUS, {
        active: newStatus,
      });

      if (response.data.status === "success") {
        setActive(newStatus);
        getSweetAlert("success", "Status updated");
      } else {
        getSweetAlert("error", "Failed to update status");
      }
    } catch (error) {
      console.error(error);
      getSweetAlert("error", "Error updating status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <div className="homeCard">
      <div className="subHomeCard">
        <Container maxWidth="xl" style={{ marginTop: "30px" }}>
          <Paper
            elevation={3}
            style={{
              padding: "24px",
              maxWidth: 600,
              marginBottom: 40,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={2}
            >
              <Typography variant="h5">Global Ban Status</Typography>

              {loading ? (
                <CircularProgress size={24} />
              ) : (
                <Button
                  variant="contained"
                  color={active ? "error" : "primary"}
                  onClick={toggleStatus}
                  disabled={loading}
                >
                  {active ? "Disable Full-Day Ban" : "Enable Full-Day Ban"}
                </Button>
              )}
            </Box>
          </Paper>
        </Container>
      </div>
    </div>
  );
};

export default UpdateGlobalData;
